/**
 * this value is used to mark invoice due date
 * as not important/not specified
 */
const UNSET_DUE_DATE_VALUE = '01/01/1900';
export const UNSET_DUE_DATE_VALUE_ISO = new Date(
  UNSET_DUE_DATE_VALUE
).toISOString();
